<template>
  <k-dialog @close="cancel" :max-width="400" :title="'Add Identity Pool'">
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label"
            >Identity Pool Name</label
          >

          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'userName'"
              v-model="identityInEdit.name"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>

        <!-- <div
        class="form-group row"
        v-if="identityInEdit.identityPoolID"
        :style="{ marginBottom: '1rem' }"
      >
        <label class="col-sm-3 text-left col-form-label">
          Identity Pool :
        </label>
        <div class="col-sm-9">
          <p class="form-control">
            {{ identityInEdit.identityPoolID }}
          </p> -->
        <!-- <kendo-multiselect
            ref="multiselect"
            v-model="identityInEdit.identityPoolID"
            :data-text-field="'name'"
            :data-value-field="'id'"
            :value-primitive="false"
            :data-source="dataSourceArray"
            :max-selected-items="1"
            :placeholder="'Select Identity Pool...'"
            :filter="'contains'"
            class="form-control"
          >
          </kendo-multiselect> -->
        <!-- </div>
      </div> -->
      </div>
      <input type="submit" id="submit-form" class="d-none" />
    </form>

    <dialog-actions-bar>
      <button class="k-button" @click="cancel">Cancel</button>
      <label class="k-button k-primary" for="submit-form" tabindex="0"
        >Save</label
      >
    </dialog-actions-bar>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import {  Input } from "@progress/kendo-vue-inputs";

export default {
  components: {
    "k-input": Input,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
  },
  props: {
    dataItem: Object,
  },
  data: function () {
    return {
      identityInEdit: {
        name: "",
      },
    };
  },
  validations: {
    identityInEdit: {},
  },
  created: function () {
    console.log(this.$props.dialogTitle);
    if (this.$props.dataItem) {
      this.identityInEdit = this.$props.dataItem;
      console.log(this.identityInEdit.roles);
    } else {
      this.identityInEdit = {
        name: "",
        identityPoolID: "",
      };
    }
  },
  mounted: function () {
    // console.log(this.$refs);
    // var t = this.$refs.multiselect.kendoWidget();
    // t.value(this.identityInEdit.roles);
    // console.log(this.identityInEdit.roles);
    // console.log(t.value());
    this.action = this.$props.dialogTitle;
  },

  computed: {},
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
        console.log("SAVED");
        console.log(this.identityInEdit.name);
        this.$emit("save");
    },
  },
};
</script>
<style scoped>
</style>